import { useState } from 'react';
import { postAPI, putAPI } from '../../api';
import TextEditor from '../TextEditor';
import { Form, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Fechas from '../Fechas';
import { useNavigate } from 'react-router-dom';
import { FormStyled } from '../Layout';
import CartelUpload from '../CartelUpload';

export default function App({ customValues, editar }) {

  const navigate = useNavigate();

  const [fileS3, setFileS3] = useState(customValues.cartel || '');

  const [subiendoObra, setSubiendoObra] = useState(false)




  /**
   ********** SUBMIT
   */
  const onSubmit = async values => {

    values.cartel = fileS3;
    values.sinopsis = window.localStorage.getItem('draftjs-content');
    values.esNueva = true;


    setSubiendoObra(true);
    try {
      if (!editar) await postAPI('obras', values);
      else await putAPI('obras', values.idMongo, values);
      alert("Cambios registrados");
      navigate(0);
    } catch (error) {
      alert(error.message || "No se pudieron guardar los cambios");
    } finally { setSubiendoObra(false); }
  }
  
  // Validation
  const required = value => (value ? undefined : ' Obligatorio')
  const mustBeNumber = value => (isNaN(value) ? ' Sólo formato numérico' : undefined)
  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  return (
    <FormStyled>
      <Form
        onSubmit={onSubmit}
        initialValues={customValues}
        mutators={{
          ...arrayMutators
        }}
        render={({
          handleSubmit,
          form: {
            mutators: { push, pop, remove }
          },
          values }) => (
            
            <form onSubmit={handleSubmit}>

            <div className='input-custom'>
              <h3>Cartel</h3>
              <CartelUpload value={fileS3} onChange={setFileS3} />
            </div>


            <div className='input-custom'>
              <h3>Titulo</h3>
              <Field
                name="titulo"
                validate={composeValidators(required)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Titulo" />
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>
            <><h3>Sinopsis</h3>
              <div className='input-sinopsis'>
                <TextEditor editorState={customValues.editorState} esNueva={customValues.esNueva}/>
              </div></>


            <div className='input-custom'>
              <h3>Autores</h3>
              <FieldArray name="autores">
                {({ fields }) => (
                  <div>
                    {fields.map((name, index) => (
                      <div key={name}>
                        <div>
                          <Field name={name} component="input" />
                          <button type="button" onClick={() => fields.remove(index)}>
                            ❌
                          </button>
                        </div>

                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => fields.push('')}
                    >
                      ➕
                    </button>
                  </div>
                )}
              </FieldArray>
            </div>

            <div className='input-custom'>
              <h3>Directores</h3>
              <FieldArray name="direccion">
                {({ fields }) => (
                  <div>
                    {fields.map((name, index) => (
                      <div key={name}>
                        <div>
                          <Field name={name} component="input" />
                          <button type="button" onClick={() => fields.remove(index)}>
                            ❌
                          </button>
                        </div>

                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => fields.push('')}
                    >
                      ➕
                    </button>
                  </div>
                )}
              </FieldArray>
            </div>

            <div className='input-custom'>
              <h3>Compañia</h3>
              <Field name="compania" component="input" placeholder="Compañia" />
            </div>

            <div className='input-custom'>
              <h3>Actores</h3>
              <FieldArray name="actores">
                {({ fields }) => (
                  <div>
                    {fields.map((name, index) => (
                      <div key={name}>
                        <div>
                          <Field name={name} component="input" />
                          <button type="button" onClick={() => fields.remove(index)}>
                            ❌
                          </button>
                        </div>

                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => fields.push('')}
                    >
                      ➕
                    </button>
                  </div>
                )}
              </FieldArray>
            </div>

            {<Field name="fechas" component={Fechas} push={push} remove={remove} />}

            <div className='input-custom'>
              <h3>Duración (minutos)</h3>
              <Field
                name="duracionMinutos"
                validate={composeValidators(required, mustBeNumber)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Duración (minutos)"  id="input-num"/>
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>


            <div className='input-custom'>
              <h3>Precio Principal</h3>
              <Field
                name="precio"
                validate={composeValidators(required, mustBeNumber)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Precio Principal"  id="input-num"/>
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>

            <div className='input-custom'>
              <h3>Precio Infantil</h3>
              <Field
                name="precio2"
                validate={composeValidators(required, mustBeNumber)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Precio Infantil"  id="input-num"/>
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>

            <div className='input-custom'>
              <h3>Precio Descuento Festival</h3>
              <Field
                name="precio3"
                validate={composeValidators(required, mustBeNumber)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Precio Festival"  id="input-num"/>
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>

            <div className='input-custom'>
              <h3>Nº Máximo de entradas</h3>
              <Field
                name="maxEntradas"
                validate={composeValidators(required, mustBeNumber)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Nº Máximo de entradas"  id="input-num" aria-describedby="max-entradas-ayuda"/>
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                    <p id="max-entradas-ayuda">Aforo de las funciones nuevas. Al cambiarlo se actualizan también las funciones futuras cuyo aforo no se haya ajustado a mano en Entradas y aforo.</p>
                  </div>
                )}
              </Field>
            </div>

            <div className='input-custom'>
              <h3>Prensa</h3>
              <FieldArray name="prensa">
                {({ fields }) => (
                  <div>
                    {fields.map((name, index) => (
                      <div key={name}>
                        <div>
                          <Field name={name} component="input" />
                          <button type="button" onClick={() => fields.remove(index)}>
                            ❌
                          </button>
                        </div>

                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => fields.push('')}
                    >
                      ➕
                    </button>
                  </div>
                )}
              </FieldArray>
            </div>
            <div className='input-custom'>
              <h3>Publicada</h3>
              <Field name="publicada" component="select">
                <option value={true}>💚 SI</option>
                <option value={false}>❌ NO</option>
              </Field>
            </div>

            <button id="btn-submit" type="submit" disabled={subiendoObra}>{editar ? <span>Guardar cambios</span> : <span>Nueva obra</span>}</button>
          </form>
        )}
      />
    </FormStyled>
  );
}
